var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _filter, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriver2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 521.453,
    height: 585.133,
    viewBox: "0 0 391.09 438.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 262h239v176.852H91zm0 0"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.672 343.992h224.781v94.86H132.672zm0 0"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.672.992h224.781v94.86H.672zm0 0"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h226v96H0z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.578 275.238h268.137v163.614H90.578zm0 0"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.578.238h268.137v163.614H.578zm0 0"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h269v164H0z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.578 157.98h62.879v65.88h-62.879zm0 0"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.578.98h62.879v65.88H.578zm0 0"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v67H0z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.71 19.543H228.63v34.395H115.71zm0 0"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.71.543H113.63v34.395H.71zm0 0"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h114v35H0z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.105 2.027h19.43v89.48h-19.43zm0 0"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.105.027h19.426v89.48H.105zm0 0"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v90H0z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 376h136v62.852H0zm0 0"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.16 361.652h49.418v32.2H25.16zm0 0"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.16.652h49.418v32.2H.16zm0 0"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v33H0z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.066 243.852h77.348v12.238h-77.348zm0 0"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.066.852H77.41V13.09H.066zm0 0"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h78v14H0z"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.578 388.852h54v11h-54zm0 0"
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.578.852h54v11h-54zm0 0"
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h55v12H0z"
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311 375h80.09v15H311zm0 0"
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.922 221.852h14.656v10.238h-14.656zm0 0"
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.922.852h14.656V11.09H.922zm0 0"
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v12H0z"
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.578 322.852h11v63h-11zm0 0"
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.578.852h11v63h-11zm0 0"
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v64H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "y"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.149994,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "B"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.0700073,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "E"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.229996,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "H"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.679993,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "K"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.679993,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "O"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.149994,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "R"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.149994,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "U"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.149994,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.229996,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.149994,
      stroke: "none"
    },
    d: "M0 0h391.09v438.85H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M196.578 95.852v-22.25a9225.627 9225.627 0 0 0 26.23-7.446L225.454.992C153.574 44.254 79.23 77.77.672 95.852"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "m247.977 19.504 2.601-14.652c-3.797-1.243-9.973-2.907-17.406-4.614C167.426 69.523 89.039 125.391.578 161.808v2.044h42.094c78.558-18.082 152.902-51.598 224.781-94.86l.594-14.613c3.215-15.05-5.445-30.098-20.07-34.875"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M63.457 49.035c-4.496-18.61-8.05-36.777-7.695-48.055-.188 5.887-41.282 17.122-47.34 29.215C4.39 38.242 2.812 46.762.578 64.852c35 5 43 1 62.879-15.817"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M70.129.637c-15.762 1.66-33.055 14.078-49.75 10.148.285.164.535.27.75.305C17.223 15.883 4.613 10.406.71 15.2c5.723 2.355 13.383 12.624 19.523 11.874A65.658 65.658 0 0 0 17 32.871c2.059-.559 4.016-1.434 5.754-2.738 24.133-19.664 53.629-20.559 77.766.894 3.293 3.293 7.94 4.22 13.109 3.825-9.957-18.43-24.453-35.739-43.5-34.215"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M8.004.754C6.704.473 5.387.234 4.07.027 5.195 14.586 4.57 29.7.22 43.672-.88 54.477 6.086 67.812 9.934 77.957c1.41 3.715 2.254 7.594 2.812 11.547 9.746-29.262 9.691-61.215-4.742-88.75"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "m5.715.652 43.863 32.196L2.058 6.406.16 5.375"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M1.805.852H77.41L.063 13.09"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M53.598.852.578 2.426l54 9.426"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "m1.54 1.172 14.038-.32L.922 11.09"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "m9.578 53.426 2-52.574-11 63 9-9"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    },
    d: "M332.578 179.852h-9v-33.5c0-2.489 2.016-4.5 4.5-4.5 2.485 0 4.5 2.011 4.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#333",
      fillOpacity: 1
    },
    d: "M329.578 202.852h-5c-6.598 0-12-5.403-12-12v-9c0-6.602 5.402-12 12-12h5c6.602 0 12 5.398 12 12v9c0 6.597-5.398 12-12 12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "M359.047 329.379c3.215-15.05-5.445-30.098-20.07-34.875l2.601-14.652c-19.02-6.215-97.297-23-98-3l57.418 147.804c18.2-5.125 36.508-10.273 54.813-15.5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "M329.578 438.852h-238v-69.5c0-58.82 47.684-106.5 106.5-106.5h25c58.817 0 106.5 47.68 106.5 106.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    transform: "translate(132 343)",
    mask: "url(#y)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    transform: "translate(90 275)",
    mask: "url(#B)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d59973",
      fillOpacity: 1
    },
    d: "M128.664 103.148c-3.086-.496-6.555-.386-8.934 1.645-3.828 3.27-2.804 9.434-.77 14.043a52.35 52.35 0 0 0 1.946 3.926c4.637 8.422 11.66 15.531 20.059 20.218 12.933 7.22 17.601-.597 14.129-12.964-3.48-12.383-13.215-24.75-26.43-26.868"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M243.36 236.484c-7.223-26.636-16.153-60.933-15.598-78.504-.184 5.887-41.282 17.122-47.34 29.215-4.809 9.598-7.668 31.196-10.176 53.196 24.371 4.652 48.742-1.391 73.113-3.907"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "M170.246 240.39c-.707 6.184-3.98 27.47-4.668 33.462-2.39 20.89 16.317 24.195 37.344 24.652.266.008.539.012.808.02 20.676.437 50.895-5.016 49.848-25.672-1.629-6.618-7.394-25.95-10.223-36.368-24.367 2.516-48.738 8.555-73.109 3.907"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    transform: "translate(172 157)",
    mask: "url(#E)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M145.36 147.387c3.488 23.691 9.695 49.984 29.171 62.465 22.11 14.164 52.7 2.734 68.559-18.715 15.855-21.453 20.129-49.867 21.5-77.032.781-15.468.765-31.226-3.277-46.132-7.86-28.957-32.97-52.942-61.528-54.649-25.914-1.55-49.898 17.106-59.09 42.125-9.62 26.192.703 64.992 4.664 91.938"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M275.727 101.848c3.324-.532 7.058-.414 9.62 1.773 4.126 3.52 3.02 10.16.829 15.121a54.533 54.533 0 0 1-2.094 4.23c-4.996 9.075-12.559 16.731-21.605 21.778-13.93 7.773-18.957-.64-15.215-13.965 3.746-13.336 14.23-26.652 28.465-28.937"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#333",
      fillOpacity: 1
    },
    d: "M263.309 133.836c-9.524-16.133-3.73-37.258-10.375-54.77-3.864-10.18-10.868-23.578-9.707-34.402-4.66 5.438-13.555 10.813-20.7 11.309-16.418 1.14-29.898-8.473-46.34-7.735-16.437.739-36.328 12.047-49.992 21.215a65.98 65.98 0 0 1 9.04-23.383c-6.141.754-13.801-9.52-19.524-11.87 3.902-4.794 16.512.683 20.418-4.11-3.524-.625-17.7-19.219-21.223-19.844C156.546 25.98 200.88-5.063 244.305.73c6.086.81 12.312 1.98 17.48 5.293 16.727 10.727 20.91 40.48 17.078 58.16-2.566 11.837-7.222 23.083-10.746 34.641-2.383 7.82-9.465 27.121-4.808 35.012M238.762 184.727a2.024 2.024 0 0 0-.504-.18c.168.062.336.117.504.18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M228.629 53.852c-5.168.394-9.816-.532-13.11-3.825-24.136-21.453-53.632-20.558-77.765-.894-1.742 1.304-3.695 2.18-5.754 2.738a65.983 65.983 0 0 0-5.805 17.582c13.664-9.168 33.555-20.476 49.993-21.215 16.44-.738 29.921 8.875 46.335 7.735 2.047-.141 4.239-.688 6.43-1.516-.11-.2-.219-.402-.324-.605"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    transform: "translate(115 19)",
    mask: "url(#H)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    transform: "translate(243 2)",
    mask: "url(#K)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M261.785 6.918c-3.273-2.098-6.969-3.332-10.781-4.164 14.434 27.535 14.488 59.488 4.742 88.75 2.063 14.703.059 30.516 7.563 43.226-4.657-7.89 2.425-27.19 4.808-35.011 3.524-11.559 8.184-22.805 10.746-34.64 3.832-17.68-.351-47.434-17.078-58.161"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M223.012 97.246c-.157-4.668-2.446-8.375-5.11-8.285-2.668.09-4.703 3.945-4.547 8.61.157 4.663 2.446 8.374 5.11 8.284 2.668-.085 4.703-3.945 4.547-8.609M175.102 98.852c-.157-4.665-2.446-8.375-5.11-8.29-2.668.09-4.703 3.946-4.547 8.614.157 4.664 2.446 8.375 5.114 8.285 2.664-.09 4.699-3.941 4.543-8.61"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#333",
      fillOpacity: 1
    },
    d: "M208.922 79.512c2.875-3.328 7.445-4.653 11.82-5.133 4.176-.457 18.324 7.152 10.57 9.734-2.519.84-8.027-2.55-10.62-3.168-1.614-.382-10.653-2.73-11.77-1.433M151.023 84.023c2.122-3.855 6.317-6.101 10.493-7.484 3.988-1.32 19.414 3.172 12.37 7.313-2.288 1.347-8.382-.82-11.046-.88-1.66-.038-10.988-.449-11.817 1.051"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M187.64 185.965c6.727 6.035 16.798 5.703 22.579-1.48 2.144-2.669-1.63-6.485-3.793-3.794-3.875 4.817-10.254 5.735-14.996 1.48-2.563-2.3-6.368 1.481-3.79 3.794"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#333",
      fillOpacity: 1
    },
    d: "M197.008 171.172c1.847-.567 3.762-1.16 5.683-.938 1.547.184 2.98.887 4.403 1.528a63.305 63.305 0 0 0 13.39 4.308c2.809.567 4.973-2.433 3.516-4.894-.64-1.086-1.172-1.965-1.406-2.254a44.726 44.726 0 0 0-7.317-7.117c-4.738-3.66-11.316-7.508-17.55-7.063-8.47.61-21.512 10.281-26.516 18.985-1.031 1.793.465 3.96 2.508 3.613 7.851-1.344 15.777-3.863 23.289-6.168"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "M250.578 243.852h-87c-3.863 0-7-3.137-7-7 0-3.868 3.137-7 7-7h87a7.001 7.001 0 0 1 0 14"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M7.996 386.496c-18.02 20.297-3.613 52.356 23.527 52.356h104.055l-75-31 15.281-15.309c-19.949-5.074-40.03-9.05-59.097-15.914"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "m144.11 293.113 53.468-14.261c-9.855-17.414-80.996-10.297-95 4l-85.816 93.777c19.07 6.863 36.863 13.148 56.816 18.219l61.836-62.446c12.524-8.945 16.274-25.898 8.695-39.289"
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    transform: "translate(25 361)",
    mask: "url(#O)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q",
    transform: "translate(168 243)",
    mask: "url(#R)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "m367.324 215.191-31.148-3.289-11.008 177.426c17.531-3.379 35.016-8.836 52.535-12.816"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "M377.703 376.512c-17.52 3.98-35.004 9.437-52.535 12.816l-1.113 17.942c-.887 14.332 10 26.804 24.75 28.363 17.191 1.812 31.941-11.805 30.867-28.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "m367.879 225-20.719.438c-11.445.246-20.918-8.833-21.16-20.278l-.086-4.101c-.242-11.446 8.832-20.914 20.274-21.16 11.445-.243 20.917 8.835 21.16 20.277"
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    transform: "translate(325 388)",
    mask: "url(#U)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "M384.09 389.426h-65.438c-3.863 0-7-3.137-7-7 0-3.867 3.137-7 7-7h65.438a7.001 7.001 0 0 1 0 14"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    transform: "translate(334 221)",
    mask: "url(#Y)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa",
    transform: "translate(82 322)",
    mask: "url(#ab)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "m67.504 405.848-56.668-32.72a7 7 0 1 1 7-12.12l56.668 32.715a7 7 0 0 1-7 12.125"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver2);
export default __webpack_public_path__ + "static/media/driver2.d312d915e7dce3eb331f6ae4af55153e.svg";
export { ForwardRef as ReactComponent };